<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">{{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.TITLE' | translate }}</h2>

  <div class="mb-6">
    <p class="text-sm text-gray-300 mb-4">
      {{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.DESCRIPTION' | translate }}
    </p>

    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.EMAIL_LABEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="email">
        <mat-hint>{{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.EMAIL_HINT' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full mb-4">
        <mat-label>{{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.PASSWORD_LABEL' | translate }}</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="motDePasse">
          <mat-hint>{{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.PASSWORD_HINT' | translate }}</mat-hint>
        </mat-form-field>

        <div class="flex items-center gap-4">
          <button
            mat-raised-button
            (click)="forcerMotDePasse()"
            [disabled]="isLoading || !isValidEmail(email) || !motDePasse"
            class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
            @if (!isLoading) {
              <mat-icon>lock_reset</mat-icon>
            }
            @if (isLoading) {
              <mat-spinner diameter="20" class="inline-block mr-2"></mat-spinner>
            }
            {{ 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.FORCE_BUTTON' | translate }}
          </button>
        </div>
      </div>
    </div>
